import type { AppStrings } from './types.js';

export const zhHans: AppStrings = {
  // COMMON
  error_title: '出错了',
  cancel: '取消',
  retry: '重试',
  back_arrow: '← 返回',

  // ASK SCREEN
  ask_box_unavailable: '问箱不可用',
  ask_box_unavailable_desc: '链接可能已过期，或对方已关闭问箱。',
  ask_create_own_box: '创建我的问箱',
  ask_sent_title: '已发送 ✅',
  ask_sent_desc: '你的匿名问题已送达对方。',
  ask_anonymous_hint: '问题将以匿名方式发送。',
  ask_placeholder: '写下你的问题…',
  ask_send: '发送',
  ask_sending: '发送中…',
  ask_error_rate_limit: '操作太频繁，请等一分钟再试。',
  ask_error_restart: '请重启 Mini App。',
  ask_error_load: '问箱加载失败。',
  ask_error_send: '问题发送失败。',
  ask_error_banned: '你已在应用中被封禁。',
  ask_banned_appeal_btn: '申诉',
  ask_appeal_sent: '申诉已提交，我们将人工处理。',

  // AGE GATE
  age_gate_title: '仅限 18 岁以上',
  age_gate_desc:
    '你正在发送匿名问题。请保持尊重：禁止骚扰、威胁、涉及未成年人的色情内容及任何违法内容。匿名不代表免责——违规行为将上报审核。发送问题即表示你已满 18 岁并同意规则。',
  age_gate_confirm: '我已满 18 岁，继续',

  // INBOX SCREEN
  inbox_title: '我的问箱',
  box_link_accordion: '邀请链接',
  inbox_notifications_ask: '🔔 允许机器人推送新问题通知吗？',
  inbox_notifications_allow: '允许',
  inbox_notifications_dismiss_label: '关闭',
  inbox_box_toggle_disable: '关闭问箱',
  inbox_box_toggle_enable: '开启问箱',
  inbox_box_disabled_warning: '问箱已关闭，暂不接受新问题。',
  inbox_share_hint: '分享链接，让朋友匿名向你提问。',
  inbox_copy: '复制',
  inbox_copied: '已复制',
  inbox_copy_error: '出错了',
  inbox_no_deeplink: '链接将在部署后出现。',
  inbox_invite_story: '通过 Story 邀请',
  inbox_invite_chat: '通过聊天邀请',
  inbox_card_rendering: '邀请卡片生成中。',
  inbox_story_unsupported: '此版本 Telegram 不支持 Story，试试「通过聊天」。',
  inbox_story_error: '无法打开 Story。',
  inbox_chat_unsupported: '此版本 Telegram 不支持分享到聊天，请更新客户端。',
  inbox_chat_error: '分享失败，请重试。',
  inbox_chat_prepare_error: '邀请内容准备失败。',
  inbox_filter_incoming: '收到的',
  inbox_filter_hidden: '已隐藏',
  inbox_filter_blocked: '已屏蔽',
  inbox_filter_empty: '这里还没有内容。',
  inbox_acc_unanswered: '未回答',
  inbox_acc_answered: '已回答',
  inbox_acc_hidden: '已隐藏',
  inbox_acc_blocked: '已屏蔽',
  inbox_empty: '还没有问题。分享上方链接吧。',
  inbox_load_more: '加载更多',
  inbox_load_more_error: '下一页加载失败。',
  inbox_error_load: '问箱加载失败。',
  inbox_rate_limit: '操作太频繁，请等一分钟再试。',
  inbox_toggle_error: '问箱状态更新失败。',

  // MESSAGE BOX (Трек D)
  message_tagline: '匿名给我留言',
  message_placeholder: '写下留言…',
  message_anonymous_hint: '留言将以匿名方式发送。',
  message_sent_title: '已发送 ✅',
  message_sent_desc: '你的匿名留言已送达。',
  message_owner_entry: '给我留言',
  message_share_hint: '分享链接，让任何人都能给你发匿名留言。',
  message_inbox_open: '收到的留言',
  message_inbox_title: '留言',
  message_inbox_empty: '还没有留言。分享上方链接吧。',

  // ANSWER SCREEN
  answer_title: '回答问题',
  answer_placeholder: '写下你的回答…',
  answer_submit: '发送',
  answer_submitting: '发送中…',
  answer_back: '返回',
  answer_error_send: '回答发送失败。',

  // SHARE SCREEN
  share_title: '回答已发布 ✅',
  share_hint: '分享卡片，收集更多问题。',
  share_card_rendering_desc:
    '卡片还在生成中。回到问题列表稍后再来——就能在 Story 或聊天中分享了。',
  share_card_alt: '回答卡片',
  share_story_btn: '分享到 Story',
  share_story_btn_busy: '打开中…',
  share_chat_btn: '分享到聊天',
  share_chat_btn_busy: '准备中…',
  share_back: '回到问题',
  share_story_unsupported: '此版本 Telegram 不支持 Story，试试「分享到聊天」。',
  share_story_error: '无法打开 Story，试试「分享到聊天」。',
  share_chat_sent: '消息已发送。',
  share_chat_unsupported: '此版本 Telegram 不支持分享到聊天，请更新客户端。',
  share_chat_error: '分享失败，请重试。',
  share_chat_prepare_error: '消息准备失败。',

  // LEADERBOARD SCREEN
  lb_title: '排行榜',
  lb_period_7d: '7 天',
  lb_period_30d: '30 天',
  lb_period_all: '全部时间',
  lb_group_label: '分类',
  lb_group_all: '全部',
  lb_group_ask: '提问',
  lb_group_rate: '评分',
  lb_group_confession: '表白',
  lb_group_guesswho: '猜猜我是谁',
  lb_group_message: '留言',
  lb_error: '排行榜加载失败',
  lb_empty: '还没有人上榜',
  lb_anon: '匿名',
  lb_load_more: '加载更多',
  lb_questions: (n) => `${n} 个问题`,
  lb_referrals: (n) => `${n} 次邀请`,

  // REWARDS SCREEN
  rw_title: '我的奖励',
  rw_error: '奖励加载失败',
  rw_level: (n) => `第 ${n} 级`,
  rw_confirmed_referrals: (n) => `${n} 位已确认好友`,
  rw_next_level_section: (n) => `下一级 — 需邀请 ${n} 位`,
  rw_to_level: (level, target) => `距第 ${level} 级：还需 ${target}`,
  rw_max_level: '已达到最高级别！',
  rw_badges_section: '徽章',
  rw_formats_section: '问箱样式',

  // QUESTION CARD
  qcard_status_new: '新',
  qcard_status_hidden: '已隐藏',
  qcard_status_answered: '已回答',
  qcard_moderation_flagged: '注意：可疑消息',
  qcard_answer_btn: '回答',
  qcard_answer_send: '发送',
  qcard_share_btn: '分享',
  qcard_hide_btn: '隐藏',
  qcard_show_btn: '显示',
  qcard_report_btn: '举报',
  qcard_block_btn: '屏蔽',
  qcard_unblock_btn: '取消屏蔽',
  qcard_report_reason_label: '选择举报原因：',
  qcard_reason_spam: '垃圾信息',
  qcard_reason_harassment: '骚扰',
  qcard_reason_sexual: '色情内容',
  qcard_reason_other: '其他',
  qcard_error_hide: '可见性更改失败。',
  qcard_error_report: '举报发送失败。',
  qcard_error_block: '屏蔽发送者失败。',
  qcard_report_done: '举报已提交，谢谢。',
  qcard_block_done: '发送者已屏蔽。',
  qcard_unblock_done: '已取消屏蔽。',

  // ERRORS
  err_network: '无法连接服务器，请检查网络后重试。',
  err_server_unavailable: '服务器暂时不可用，请稍后重试。',
  err_internal: '出了点小问题，我们正在处理——请稍后再试。',
  err_bad_request: '请检查填写的内容。',
  err_generic: '操作未完成，请稍后重试。',
  err_schema: '数据异常，请尝试更新应用。',
  share_story_link_premium_note:
    'Story 中的可点击链接需要 Telegram Premium。没有 Premium 也没关系——你的用户名已显示在卡片上。',

  // AUTH ERROR SCREEN
  auth_error_title: '访问出错',
  auth_error_desc: '登录失败。请从 Telegram 中关闭并重新打开 Mini App。',

  // REWARD TOAST
  reward_toast_title: '新奖励！',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: '问题',
  tab_leaderboard: '排行榜',
  tab_rewards: '奖励',
  tab_settings: '设置',

  // SETTINGS SCREEN
  settings_title: '设置',
  settings_section_general: '通用',
  settings_notifications: '新问题通知',
  settings_notifications_hint: '有人提问时，机器人会向你发消息。',
  settings_notifications_error: '通知设置保存失败。',
  settings_language: '语言',
  settings_language_error: '语言切换失败，请重试。',
  settings_section_about: '关于',
  settings_version: '版本',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story 链接仅限 Premium',
  code_modal_explain:
    'Telegram 仅向 Premium 用户提供可点击的 Story 链接。你可以在 Story 中写上你的代码——观众在应用里输入代码就能匿名向你提问。',
  code_modal_your_code: '你的代码',
  code_modal_copy: '复制代码',
  code_modal_copied: '已复制',
  code_modal_share_btn: '分享到 Story',
  code_modal_loading: '正在获取代码…',
  code_modal_error: '获取代码失败，请稍后重试。',
  ask_code_title: '输入代码',
  ask_code_desc: '从 Story 来的？找到其中的代码（例如 1234）并在下方输入。',
  ask_code_placeholder: 'Story 中的代码',
  ask_code_find: '查找',
  ask_code_not_found: '未找到该代码，请检查数字后重试。',
  ask_code_invalid: '代码为 4 位数字。',
  code_onboarding_header: '从 Story 来的？',
  code_onboarding_text: '输入朋友的代码，向他匿名提问。',
  code_onboarding_action: '输入代码',
  settings_ask_by_code: '通过代码提问',
  settings_my_code_title: '你的 Story 代码',
  settings_my_code_hint:
    '把这个代码写进 Story——观众输入后就能向你匿名提问。Telegram 仅向 Premium 用户提供可点击链接。',
  settings_my_code_rotate: '获取新代码',
  settings_my_code_rotating: '更新中…',
  settings_my_code_done: '代码已更新',
  settings_my_code_error: '获取代码失败。',
  settings_my_code_rotate_confirm_title: '要更换代码吗？',
  settings_my_code_rotate_confirm_desc:
    '旧代码会立刻失效，之前在你 Story 里看到它的人就再也联系不上你了。只有在有人骚扰你时才更换。',
  settings_my_code_rotate_confirm_action: '更换代码',

  // BOT
  bot_greeting: (name) => (name ? `你好，${name}！👋` : '你好！👋'),
  bot_onboarding:
    '这是 VeylMe — 匿名提问。\n\n' +
    '打开 Mini App，在你的 Story 发布「匿名问我」卡片 — ' +
    '匿名问题就会直接发到这里。\n\n' +
    '⚠️ 18+。请文明互动：欺凌、威胁和违禁内容 ' +
    '均不允许。匿名 ≠ 免责 — 违规行为将上报审核。',
  bot_open_btn: '打开 VeylMe',
  notify_answer_btn: '回答',
  bot_invite_text:
    '有人分享了 VeylMe 链接。\n\n' +
    '打开 Mini App 匿名提问：',
  bot_invite_btn: '匿名提问',

  // WORK-027 i18n sweep
  tagline: '匿名问我问题',
  share_ask_action: '提问',
  share_answered_text: '我回答了一个匿名问题 👀',
  err_not_in_telegram: 'Mini App 未在 Telegram 中运行，请重启应用。',
  badge_viral_starter: '病毒式起步',
  badge_storyteller: '讲故事的人',
  badge_loop_master: '循环大师',
  theme_confession: '表白',
  theme_guesswho: '猜猜我是谁',
  rw_format_named: (name) => `样式「${name}」`,
  card_label_question: '问题',
  card_label_answer: '回答',
  card_invite_subtitle: '匿名，无需注册',
  card_code_hint: '在应用中输入代码',
  share_msg_title: (brand) => `${brand} · 匿名提问`,
  notify_new_question: '🔔 有人向你提了一个匿名问题',
  notify_unanswered_reminder: (n) => `🔔 你有 ${n} 个未回答的问题`,
  notify_ban_permanent: '永久',
  notify_ban_until: (date) => `到 ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ 你在 VeylMe 中被封禁${untilPhrase}。太多接收者举报了你的消息。\n如果你认为这是误判，可以在应用中提交申诉。`,
  notify_warning_msg: '⚠️ 有多位接收者举报了你的消息。再多一些就会在 VeylMe 中被封禁。',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: '我的问题',
  my_questions_empty_title: '你还没有提过问题',
  my_questions_empty_desc: '在别人的信箱里提个问题——回复会显示在这里。',
  my_questions_loading: '正在查看是否有回复…',
  my_questions_waiting: '等待回复',
  my_questions_answer_label: '回复',
  settings_my_questions: '我的问题',
  ask_sent_find_reply_hint: '之后可以在“我的问题”里找到回复。',
  inbox_story_nonpremium_hint: '没有 Telegram Premium 时，Story 链接不可点击，所以我们显示一个代码——分享到聊天更可靠。',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram 通行证已过期',
  session_expired_desc: 'Telegram 只在启动时给应用发一次通行证，而这一张已经过期了。请重新打开应用——你写了一半的内容我们已经保存。',
  session_expired_desc_no_storage: '你的 Telegram 通行证已过期，需要重新打开应用。我们没能保存你输入的内容——离开前请先复制一下。',
  session_expired_reopen: '重新打开',
  session_expired_stuck_title: 'Telegram 返回了同一张旧通行证',
  session_expired_stuck_desc: '请从机器人菜单里彻底关闭应用，然后重新打开——这样 Telegram 才会发新的通行证。',
  session_auth_failed_title: '无法确认登录',
  session_auth_failed_desc: 'Telegram 没有确认你登录了应用。请关闭应用，再从与机器人的聊天里重新打开。',
  session_expired_manual_close: '应用无法在这里自己关闭——请你自己关掉它，再从与机器人的聊天里重新打开。',
  session_expiring_soon: 'Telegram 通行证快要过期了。请重新打开应用，以免丢失内容。',
  my_questions_check_failed: '无法查看是否有回复。请稍后再试。',
  settings_notifications_load_error: '无法加载该设置。',
};
